import Swiper from 'swiper';
import { Navigation, A11y, FreeMode } from 'swiper/modules';
import { animate } from '../../core/animations';
import sliderADA from '../../components/slider/ada';

const initSlider = (slider) => {
  const swiper = new Swiper(slider, {
    modules: [ Navigation, A11y, FreeMode ], // https://swiperjs.com/swiper-api#using-js-modules
    a11y: {
      enabled: true,
      prevSlideMessage: window.theme.strings.swiperPrevSlide,
      nextSlideMessage: window.theme.strings.swiperNextSlide,
      containerMessage: window.theme.strings.swiperContainer,
    },
    slidesPerView: 2.2,
    slidesPerGroup: 2,
    spaceBetween: 8,
    loop: true,
    loopAddBlankSlides: false,
    autoHeight: true,
    freeMode: true,
    autoplay: false,
    // navigation: false,
    breakpoints: {
      769: {
        slidesPerView: 2,
        slidesPerGroup: 1,
        spaceBetween: 8,
        freeMode: false,
        autoHeight: true,
        navigation: {
          nextEl: '.category-two-sides .swiper-button-next',
          prevEl: '.category-two-sides .swiper-button-prev',
        },
      },
      1500: {
        slidesPerView: 3,
        slidesPerGroup: 1,
        spaceBetween: 8,
        freeMode: false,
        autoHeight: true,
        navigation: {
          nextEl: '.category-two-sides .swiper-button-next',
          prevEl: '.category-two-sides .swiper-button-prev',
        },
      }
    },
    on: {
      init: function () {
        animate();
        sliderADA(document.querySelector('.category-two-sides .swiper'));
      },
    }
  });
};

export default () => {
  if (!$('.category-two-sides').length) {
    return;
  }

  const $sliders = $('.category-two-sides .swiper');

  if (!$sliders.length) {
    return;
  }

  _.each($sliders, (slider) => {
    initSlider(slider);
  });
};
